/**
 * Appearance service — thin wrappers over /api/appearance/* and /api/admin/appearance/*.
 */
import api from "./api";

export const PRESET_CACHE_KEY = "ap:effective_preset";

// --------- Client ---------

export async function fetchEffectivePreset() {
    const res = await api.get("/appearance/me");
    return res.data || res;
}

// --------- Admin: Presets ---------

export async function adminListPresets(params = {}) {
    const res = await api.get("/admin/appearance/presets", { params });
    return res.data || res;
}

export async function adminGetPreset(id) {
    const res = await api.get(`/admin/appearance/presets/${id}`);
    return res.data || res;
}

export async function adminCreatePreset(payload) {
    const res = await api.post("/admin/appearance/presets", payload);
    return res.data || res;
}

export async function adminUpdatePreset(id, payload) {
    const res = await api.patch(`/admin/appearance/presets/${id}`, payload);
    return res.data || res;
}

export async function adminDuplicatePreset(id) {
    const res = await api.post(`/admin/appearance/presets/${id}/duplicate`, {});
    return res.data || res;
}

export async function adminDeletePreset(id) {
    const res = await api.delete(`/admin/appearance/presets/${id}`);
    return res.data || res;
}

// --------- Admin: Settings ---------

export async function adminGetAppearanceSettings() {
    const res = await api.get("/admin/appearance/settings");
    return res.data || res;
}

export async function adminUpdateAppearanceSettings(payload) {
    const res = await api.patch("/admin/appearance/settings", payload);
    return res.data || res;
}

// --------- Admin: Overrides ---------

export async function adminListOverrides(params = {}) {
    const res = await api.get("/admin/appearance/overrides", { params });
    return res.data || res;
}

export async function adminUpsertOverride(userId, payload) {
    const res = await api.patch(
        `/admin/appearance/overrides/${userId}`,
        payload,
    );
    return res.data || res;
}

export async function adminDeleteOverride(userId) {
    const res = await api.delete(`/admin/appearance/overrides/${userId}`);
    return res.data || res;
}

// --------- Admin: User search for override assignment ---------

export async function adminSearchUsers(q, limit = 20) {
    const res = await api.get("/admin/appearance/users/search", {
        params: { q, limit },
    });
    return res.data || res;
}
